module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('el-table', {
    ref: "tradeTable",
    attrs: {
      "element-loading-text": "拼命加载中",
      "data": _vm.tableData.list,
      "border": "",
      "row-key": _vm.getRowKeys
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          ref: "tradeTable",
          attrs: {
            "element-loading-text": "拼命加载中",
            "data": _vm.tableData.list[props.$index].orderPro,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "productName",
            "label": "商品名称"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "SKU",
            "label": "商品SKU"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "proTotal",
            "label": "商品单价"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_vm._v("￥" + _vm._s(scope.row.proTotal / 100))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "discount",
            "label": "优惠金额"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_vm._v("￥" + _vm._s(scope.row.discount / 100))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "proPayTotal",
            "label": "实付金额"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_vm._v("￥" + _vm._s(scope.row.proPayTotal / 100))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "proStatus",
            "label": "商品状态"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.tableData.list[props.$index].payStatus == 'not') ? _c('div', [_c('div', [_vm._v("待付款")])]) : (_vm.tableData.list[props.$index].payStatus == 'ok') ? _c('div', [(_vm.tableData.list[props.$index].outStatus == '0' && _vm.tableData.list[props.$index].refStatus == '0' && _vm.tableData.list[props.$index].orderStatus == '0') ? _c('div', [_vm._v("待取货")]) : _vm._e(), _vm._v(" "), (_vm.tableData.list[props.$index].outStatus == '0' && _vm.tableData.list[props.$index].refStatus == '1' && _vm.tableData.list[props.$index].expStatus != '2') ? _c('div', [_vm._v("取消出货")]) : _vm._e(), _vm._v(" "), (_vm.tableData.list[props.$index].outStatus == '0' && _vm.tableData.list[props.$index].refStatus == '4' && _vm.tableData.list[props.$index].expStatus != '2') ? _c('div', [_vm._v("取消出货")]) : _vm._e(), _vm._v(" "), (_vm.tableData.list[props.$index].outStatus == '0' && _vm.tableData.list[props.$index].payStatus == 'ok' && _vm.tableData.list[props.$index].expStatus == '2') ? _c('div', [_vm._v("创建提货码失败")]) : _vm._e(), _vm._v(" "), (scope.row.proStatus == '出货成功') ? _c('div', [_vm._v("出货成功")]) : _vm._e(), _vm._v(" "), (scope.row.proStatus == '出货失败') ? _c('div', [_vm._v("出货失败")]) : _vm._e()]) : _c('div', [_c('div', [_vm._v("支付异常")])])]
            }
          }])
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderId",
      "label": "订单编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kioskNo",
      "label": "机器编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.outStatus == '2') ? _c('div', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("\n                                " + _vm._s(scope.row.shipmentNum) + "/" + _vm._s(scope.row.orderPro.length) + "\n                            ")]) : _c('div', [_vm._v("\n                                " + _vm._s(scope.row.shipmentNum) + "/" + _vm._s(scope.row.orderPro.length) + "\n                            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "timeStart",
      "label": "订单时间",
      "formatter": _vm.startformatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderStatus",
      "label": "订单状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.payStatus == 'not' && scope.row.orderStatus == '0') ? _c('div', [_vm._v("\n                                待付款\n                            ")]) : _c('div', [(scope.row.refStatus == '3') ? _c('div', [_vm._v("\n                                    退款中\n                                ")]) : (scope.row.outStatus == '2' && scope.row.refStatus == '0' || scope.row.refStatus == '2' && scope.row.orderStatus == '2') ? _c('div', [_vm._v("\n                                    待处理\n                                ")]) : (scope.row.outStatus == '0' && scope.row.refStatus == '0' && scope.row.payStatus == 'ok' && scope.row.orderStatus == '0') ? _c('div', [_vm._v("\n                                    待取货\n                                ")]) : (scope.row.refStatus == '1' && scope.row.outStatus == '2' && scope.row.orderStatus == '1') ? _c('div', [_vm._v("\n                                    已完成\n                                ")]) : (scope.row.orderStatus == '1' && scope.row.refStatus == '0' && scope.row.outStatus == '1') ? _c('div', [_vm._v("\n                                    已完成\n                                ")]) : _vm._e(), _vm._v(" "), (scope.row.refStatus == '4') ? _c('div', [_vm._v("\n                                    申请退款\n                                ")]) : (scope.row.orderStatus == '3') ? _c('div', [_vm._v("\n                                    已关闭\n                                ")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payMode",
      "label": "支付方式"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payTotal",
      "label": "实付金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("￥" + _vm._s(scope.row.payTotal / 100))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "label": "修改时间",
      "formatter": _vm.updateformatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "155px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "disabled": scope.row.payStatus != 'ok'
          },
          on: {
            "click": function($event) {
              _vm.refProductOpen(scope.row)
            }
          }
        }, [_vm._v("退款")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentpage,
      "page-count": _vm.pagesCount,
      "page-sizes": _vm.pagesizes,
      "page-size": _vm.pagesize,
      "total": _vm.pagesCount,
      "layout": " total, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-chahange": _vm.handleSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b00e532!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/order/table.vue
// module id = 1066
// module chunks = 2